import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function PortfolioMultipolar() {
  return (
    <section data-testid="pf-multipolar" className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="border border-white/10 bg-white/[0.02] rounded-sm"
        >
          <img
            src="/images/hero-1024.webp"
            alt="Silhouette face à un globe terrestre, MULTIPOLAR"
            width={1024}
            height={576}
            loading="lazy"
            decoding="async"
            className="w-full aspect-video object-cover"
            data-testid="pf-multipolar-image"
          />
          <div className="p-8 md:p-10 text-center">
            <span className="micro-label">MULTIPOLAR</span>
            <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] mt-6">
              Comprendre la <span className="italic text-[#FF6B00]">grille de lecture</span>.
            </h2>
            <p className="mt-8 text-[#D8D4CC] font-light max-w-[70ch] mx-auto">
              OPENACCESS montre ce que je fais. MULTIPOLAR explique comment je lis le monde :
              un programme vidéo en cinq actes sur les rapports de force, la technologie et les
              capitaux. Abonné depuis 3 mois ? Tu bénéficies de 15 % de réduction sur MULTIPOLAR.
            </p>
            <Link
              to="/multipolar"
              data-testid="pf-multipolar-button"
              className="mt-10 inline-flex items-center gap-3 border border-white/20 hover:bg-white/5 text-[#F5F5F0] font-mono text-xs tracking-[0.2em] uppercase px-8 py-4 rounded-sm transition-colors duration-300"
            >
              Découvrir MULTIPOLAR
              <ArrowUpRight size={14} />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
